import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FormControl } from "@angular/forms";

@Component({
	selector: "sanremo-datepicker",
	templateUrl: "./datepicker.component.html",
	styles: []
})
export class DatepickerComponent extends FieldType {
	faCalenderAlt = faCalendarAlt;

	onSelectedDate(event) {
		if (this.to.callback) this.to.callback(event);
	}
}
